import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../Services/auth.service';
import { LanguageService } from '../Services/language.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private languageService: LanguageService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentUser = this.authService.userToken;
    if (currentUser) {
      request = request.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: `Bearer ${this.authService.userToken['accessToken']}`,
          Language: this.languageService.currentLanguage
        }
      });
    }

    return next.handle(request);
  }
}
